














































































































import SearchIcon from './SearchIcon.vue'
import FilterIcon from './FilterIcon.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { has } from 'underscore'
import { mapActions, mapState } from 'vuex'

window.onclick = (event) => {
  if (!event.target.matches('.dropdown-btn')) {
    const dropdowns = document.getElementsByClassName('dropdown-menu-packages')
    for (let i = 0; i < dropdowns.length; i++) {
      const openDropdown = dropdowns[i]
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show')
      }
    }
  }
}

@Component({
  components: {
    SearchIcon,
    FilterIcon,
  },
  computed: {
    ...mapState('pickup', ['page']),
    ...mapState(['pickup']),
  },
  methods: {
    ...mapActions('pickup', ['filterByNameOrStatus']),
  },
})
export default class FilterBar extends Vue {
  @Prop(Object) filterOptions: any
  @Prop(Boolean) activeDetail: boolean

  name: string = ''
  filterByNameOrStatus: any
  selectedTemplateEforms: any
  pickup: any
  pickupOption: boolean = false
  stateOption: boolean = false
  statusOption: any = {
    active: false,
    inactive: false,
  }
  actionDocumentsApprove: number = 78
  data() {
    return {
      selectedTemplateEforms: '',
    }
  }
  filterByName(event) {
    if (this.name !== event.target.value) {
      this.name = event.target.value
      this.filterOptions.nombre = event.target.value
      this.filterOptions.page = 1
      this.filterByNameOrStatus(this.filterOptions)
    }
  }

  pickupFilter() {
    if (!this.pickupOption) {
      this.pickupOption = true
      this.filterOptions.pickup = 1
    } else {
      delete this.filterOptions['pickup']
      this.pickupOption = false
    }

    this.filterOptions.page = 1
    this.filterByNameOrStatus(this.filterOptions)
  }

  get statusMessage() {
  if (this.statusOption.active && !this.statusOption.inactive) {
    return this.$t('message.uploadImageComponent.filterBar.active')
  }

  return this.$t('message.uploadImageComponent.filterBar.inactive')
}

  toggleDropDown() {
    const element = document.querySelector('.dropdown-menu-packages')
    element.classList.toggle('show')
  }

  statusFilter(status) {
    if (status === 'active') {
      this.statusOption.active = !this.statusOption.active
    } else {
      this.statusOption.inactive = !this.statusOption.inactive
    }

    if (this.statusOption.active) {
      this.stateOption = true
      this.filterOptions.estado = 1
    }

    if (this.statusOption.inactive) {
      this.stateOption = true
      this.filterOptions.estado = 0
    }

    if (this.statusOption.active && this.statusOption.inactive) {
      this.stateOption = false
      delete this.filterOptions['estado']
    }

    if (!this.statusOption.active && !this.statusOption.inactive) {
      this.stateOption = false
      delete this.filterOptions['estado']
    }
    this.filterOptions.page = 1
    this.filterOptions.idTemplates = ''
    this.filterByNameOrStatus(this.filterOptions)
  }

  closeFilter(element) {
    if (element === 'pickup') {
      delete this.filterOptions['pickup']
      this.pickupOption = false
    }

    if (element === 'status') {
      delete this.filterOptions['estado']
      this.statusOption.active ? (this.statusOption.active = false) : ''
      this.statusOption.inactive ? (this.statusOption.inactive = false) : ''
      this.stateOption = false
    }
    if (element === 'package') {
      this.selectedTemplateEforms = ''
      const eformsSelect = document.getElementById(
        'eformsSelect'
      ) as HTMLSelectElement
      eformsSelect.selectedIndex = 0
      delete this.filterOptions['pickup']
    }

    this.filterOptions.page = 1
    this.filterOptions.idTemplates = ''
    this.filterByNameOrStatus(this.filterOptions)
  }

  get pickupActionEnable() {
    return this.$store.getters['isActionAllowed'](this.actionDocumentsApprove)
  }

  get templateEfoms() {
    return this.pickup.templatesEform.data
  }

  filterTable(event) {
    const index = event.target.selectedIndex
    this.selectedTemplateEforms = event.target[index].text

    const filterPackage = this.pickup.templatesEform.data.filter(
      (item) => item.id == event.target.value
    )
    let filterToSearch = []
    filterPackage[0].templates.forEach((item) => {
      filterToSearch.push(item.id)
    })

    this.filterOptions.page = 1
    this.filterOptions.idTemplates = JSON.stringify([
      { value: filterToSearch.toString() },
    ])
    this.filterByNameOrStatus(this.filterOptions)
  }
}
